<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.vista=='completa'">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; ARTICOLO DI VENDITA</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light"  @click="bAnnulla" :disabled="interfacciaBloccata || !elementoDaAggiornare">Annulla</button>
                    <button class="button is-primary" @click="bSalva" :disabled="interfacciaBloccata || !elementoDaAggiornare">Salva</button>
                </div>                
            </div>
            <div class="column">
                <p v-if="idElementoSelezionato!='-1' && idElementoSelezionato!='-2'">
                    <a @click="bSelezionaListino()" title="Vai al listino"> &nbsp; {{ dbListini[idListinoSelezionato]?.informazioni?.nome || "Listino" }} </a>
                </p>
                <div v-else>
                    <CampoTendina @valoreCambiato="listinoDestinazioneModifica"
                        :valore="String(idListinoSelezionato)"
                        idTendina="listini"
                        etichetta="Listino di destinazione"/>
                </div>
            </div>
            <div class="column">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idElementoSelezionato!='-1' && idElementoSelezionato!='-2'">Elimina</button>
                </div>
            </div>
        </div>

        <div class="columns">
        </div>

        <div class="columns">
            <div class="column is-2" v-if="idElementoSelezionato!='-1' && idElementoSelezionato!='-2'">
                <div class="field">
                    <label class="label">Codice</label>
                    <div class="control is-expanded">
                        <input class="input" disabled="true" type="text" :value="leggiInfoDBRaw(elementoSelezionato)?.id">
                    </div>
                </div>
            </div>
            <div class="column is-2" v-if="idElementoSelezionato=='-1' || idElementoSelezionato=='-2'">
                <div class="field">
                    <label class="label">Codice</label>
                    <div class="control is-expanded">
                        <input class="input" type="text" v-model="idTemporaneo" @change="elementoModifica(idTemporaneo, 'id')">
                    </div>
                </div>
            </div>
            <div class="column is-3">
                <CampoPrListinoDoppio @valoreCambiato="elementoModifica"
                    :valore=arrayPrListino()
                    identificativo="listinoAcquistoVendita"
                    etichetta="Listino Acquisto/Vendita"/>
            </div>
            <div class="column is-1 has-text-right">
                <label class="label"> &nbsp; </label>
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <button class="button is-primary" @click="elementoModifica(null, 'ricaricoArticolo')" title="Disattiva ricarico/sconto articolo" v-if="elementoSelezionato.rcAcq"><p>
                            <i class="fas fa-toggle-on"></i></p></button>
                        <button class="button is-primary" @click="elementoModifica(null, 'ricaricoArticolo')" title="Attiva ricarico/sconto articolo" v-if="!elementoSelezionato.rcAcq"><p>
                            <i class="fas fa-toggle-off"></i></p></button>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <CampoRicarico @valoreCambiato="elementoModifica"
                    :solaLettura="!('rcAcq' in elementoSelezionato)"
                    :valore="elementoSelezionato.rcAcq?elementoSelezionato.rcAcq:dbListini[idListinoSelezionato]?.informazioni?.rcAcq"
                    identificativo="rcAcq"
                    etichetta="Ric./sc. Acquisto"/>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Unità</label>
                    <div class="control is-expanded">
                        <input class="input has-text-centered" type="text" v-model="elementoSelezionato.unita"  @change="elementoModifica(elementoSelezionato.unita, 'unita')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Costo</label>
                    <div class="control is-expanded">
                        <input class="input has-text-centered" type="text" disabled="true" :value="generaStringa(costoArticolo, '0,00', true)">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-12">
                <div class="field">
                    <label class="label">Descrizione</label>
                    <div class="control">
                        <textarea class="textarea" placeholder="Descrizione"  rows="8" v-model="elementoSelezionato.descrizione" @change="elementoModifica(elementoSelezionato.descrizione, 'descrizione')"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-12">
                <div class="field">
                    <label class="label">Note</label>
                    <div class="control">
                        <textarea class="textarea" placeholder="Note"  rows="3" v-model="elementoSelezionato.note" @change="elementoModifica(elementoSelezionato.note, 'note')"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>

</template>

<script setup>
    import CampoTendina from "./CampoTendina.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    import CampoPrListinoDoppio from "./CampoPrListinoDoppio.vue";
    import CampoRicarico from "./CampoRicarico.vue";
    // FIX: Importato watch
    import { defineProps, defineEmits, ref, nextTick, watch, computed } from "vue";
    import { dbListini, salvaArticoloListinoInFirestore, eliminaArticoloListinoInFirestore, leggiInfoDBRaw, aggiungiInfoDB } from "./../code/gestioneDB";
    import { clonaOggetto, copiaTrasporto, generaStringa, costoVocePreventivo } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idArticolo: {
            type: String,
            default: '-1'
        },
        idListino: {
            type: Number,
            default: 1
        },
        vista: {                    // completa, ridotta
            type: String,
            default: 'completa'
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso','statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE
    // FIX: Inizializzato come ref({}) per coerenza e sicurezza
    const elementoSelezionato = ref({});          
    const elementoDaAggiornare = ref(false);        
    const arrayRcAcq = ref([]);
    const messaggioModale = ref(null);              
    const idElementoSelezionato = ref(props.idArticolo);
    const idTemporaneo = ref(props.idArticolo == '-1' || props.idArticolo == '-2' ? '' : props.idArticolo);
    const idListinoSelezionato = ref(props.idListino);
    const interfacciaBloccata = ref(false);
    const formAttivo = ref(true);                   

    // FIX: Watcher di sicurezza per cambi asincroni
    watch(() => props.idArticolo, (nuovoId) => {
        idElementoSelezionato.value = nuovoId || '-1';
        setupForm();
    });
    watch(() => props.idListino, (nuovoId) => {
        idListinoSelezionato.value = nuovoId;
    });

    const costoArticolo = computed(() => {
        const art = elementoSelezionato.value;
        if (!art) return 0;
        
        let tempVoce = {};
        if (art.prListino) {
            tempVoce = {
                prListino: art.prListino,
                rcAcq: art.rcAcq || dbListini.value[idListinoSelezionato.value]?.informazioni?.rcAcq
            };
        } else {
            tempVoce = {
                prListinoAcq: art.prListinoAcq,
                rcAcq: art.rcAcq || dbListini.value[idListinoSelezionato.value]?.informazioni?.rcAcq
            };
        }
        return costoVocePreventivo(tempVoce);

    });

    // SETUP DEL COMPONENTE
    setupForm();

    // FUNZIONI DEL COMPONENTE
    function setupForm() {
        const id = idElementoSelezionato.value;
        idListinoSelezionato.value = props.idListino;
        
        // FIX: Scheletro di Base 
        const scheletroBase = {
            descrizione: '',
            unita: '',
            note: ''
        };

        elementoSelezionato.value = {};

        if ( id == '-1' ) {
            elementoSelezionato.value = { ...scheletroBase };
            idTemporaneo.value = '';
            aggiungiInfoDB(elementoSelezionato.value, {
                id: null
            });
        } else if ( id == '-2' ){
            // Sto facendo 'incolla'
            elementoSelezionato.value = { ...scheletroBase, ...clonaOggetto(copiaTrasporto.value.articoloListino) };
            elementoDaAggiornare.value = clonaOggetto(copiaTrasporto.value.articoloListino);
            idTemporaneo.value = copiaTrasporto.value.articoloListinoCodiceOriginale || '';
            aggiungiInfoDB(elementoSelezionato.value, {
                id: idTemporaneo.value
            });
        } else {
            // FIX: Estrazione protetta
            const listinoOriginale = dbListini.value[idListinoSelezionato.value];
            const articoloOriginale = (listinoOriginale && listinoOriginale.articoli) ? listinoOriginale.articoli[id] : null;

            if (articoloOriginale) {
                elementoSelezionato.value = { ...scheletroBase, ...clonaOggetto(articoloOriginale) };
                idTemporaneo.value = id;
                
                // Ricostruzione DNA
                const infoRaw = leggiInfoDBRaw(articoloOriginale) || { id: id };
                aggiungiInfoDB(elementoSelezionato.value, infoRaw);
            } else {
                elementoSelezionato.value = { ...scheletroBase };
                idTemporaneo.value = id;
                aggiungiInfoDB(elementoSelezionato.value, { id: id });
            }
        }
        
        arrayRcAcq.value = creaArrayRcAcq();
        elementoDaAggiornare.value = false;
        emit('modificaElementoInCorso', false);
        resetForm();
    }

    function elementoModifica(valore, etichetta) {
        switch (etichetta) {
            case 'id':
                if (valore.length < 3) {
                    return;
                } else {
                    aggiungiInfoDB(elementoSelezionato.value, {
                        id: valore
                    });
                }
                break;
            case 'ricaricoArticolo':
                if ('rcAcq' in elementoSelezionato.value) {
                    delete elementoSelezionato.value.rcAcq;
                } else {

                    const rcAcqOriginale = dbListini.value[props.idListino]?.informazioni?.rcAcq;

                    // Estrazione esplicita per valore: funziona sia se rcAcqOriginale è un Array [a,b,c] 
                    // sia se è un Oggetto trasformato {0:a, 1:b, 2:c}
                    elementoSelezionato.value.rcAcq = rcAcqOriginale 
                        ? [rcAcqOriginale[0] || 0, rcAcqOriginale[1] || 0, rcAcqOriginale[2] || 0] 
                        : undefined;
                    // elementoSelezionato.value.rcAcq = dbListini.value[idListinoSelezionato.value]?.informazioni?.rcAcq;
                }
                arrayRcAcq.value = creaArrayRcAcq();
                resetForm();
                break;
            case 'listinoAcquistoVendita':
                if (valore.length==1) {
                    elementoSelezionato.value.prListino = valore[0];
                    delete elementoSelezionato.value.prListinoAcq;
                    delete elementoSelezionato.value.prListinoVen;
                } else {
                    elementoSelezionato.value.prListinoAcq = valore[0];
                    elementoSelezionato.value.prListinoVen = valore[1];
                    delete elementoSelezionato.value.prListino;
                }
                resetForm();
                break;
            default:
                elementoSelezionato.value[etichetta] = valore;
                resetForm();
        }
        if (!elementoDaAggiornare.value) {
            elementoDaAggiornare.value = true;
            emit('modificaElementoInCorso', true);
        }
    }

    function listinoDestinazioneModifica(nuovoIdListino) {
        idListinoSelezionato.value = parseInt(nuovoIdListino);
        arrayRcAcq.value = creaArrayRcAcq(); // Ricalcola i ricarichi predefiniti per il nuovo listino
        if (!elementoDaAggiornare.value) {
            elementoDaAggiornare.value = true;
            emit('modificaElementoInCorso', true);
        }
    }

    function bAnnulla() {
        if (elementoDaAggiornare.value) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        }
    }

    function bSalva() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche all'articolo?"
        };
    }

    async function bComandoModale(comando) {
        // FIX: Raggruppati in scope isolati ({ }) per ESLint
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupForm();
                break;
            }
            case 'salva': {
                const infoId = leggiInfoDBRaw(elementoSelezionato.value)?.id || '';
                
                if ((props.idArticolo=='-1' || props.idArticolo=='-2') && infoId.length < 3) {
                    messaggioModale.value = {
                        testoLight:{testo:'Annulla', comando:'annulla'},
                        testoPrimary:null,
                        testoDanger:null,
                        messaggio:"Il codice dell'articolo deve essere di almeno 3 caratteri"
                    };
                } else if ((props.idArticolo=='-1' || props.idArticolo=='-2') && dbListini.value[idListinoSelezionato.value]?.articoli?.[infoId]) {
                    messaggioModale.value = {
                        testoLight:{testo:'Annulla', comando:'annulla'},
                        testoPrimary:null,
                        testoDanger:null,
                        messaggio:"Il codice dell'articolo è già utilizzato"
                    };
                } else {
                    if (await salvaArticoloListinoInFirestore(elementoSelezionato.value, idListinoSelezionato.value)) {
                        console.log('Articolo salvato correttamente');
                    } else {
                        console.log('Errore nel salvataggio dell\'articolo');
                    }
                    if (props.idArticolo=='-1' || props.idArticolo=='-2') {
                        emit('elementoSelezionato', {
                            tipo: 'articoloListino',
                            idListino: idListinoSelezionato.value,
                            idArticoloListino: infoId
                        });
                    }
                    setupForm();
                    messaggioModale.value = null;
                    emit('modificaElementoInCorso', false);
                }
                break;
            }
            case 'elimina': {
                const infoId = leggiInfoDBRaw(elementoSelezionato.value)?.id || props.idArticolo;
                eliminaArticoloListinoInFirestore(infoId, idListinoSelezionato.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'listini',
                    idListino: idListinoSelezionato.value
                });
                break;
            }
            case 'selezionaListino': {
                emit('elementoSelezionato', {
                    tipo: 'listini',
                    idListino: props.idListino
                });
                break;
            }
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

    function bSelezionaListino() {
        if (elementoDaAggiornare.value) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Cancella le modifiche e prosegui', comando:'selezionaListino'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        } else {
            emit('elementoSelezionato', {
                tipo: 'listini',
                idListino: props.idListino
            });
        }
    }

    function creaArrayRcAcq() {
        let tempArrayRcAcq = [];
        if ('rcAcq1' in elementoSelezionato.value) {
            elementoSelezionato.value.rcAcq1?tempArrayRcAcq.push(elementoSelezionato.value.rcAcq1):tempArrayRcAcq.push(0);
            elementoSelezionato.value.rcAcq2?tempArrayRcAcq.push(elementoSelezionato.value.rcAcq2):tempArrayRcAcq.push(0);
            elementoSelezionato.value.rcAcq3?tempArrayRcAcq.push(elementoSelezionato.value.rcAcq3):tempArrayRcAcq.push(0);
        } else {
            tempArrayRcAcq.push(dbListini.value[idListinoSelezionato.value]?.informazioni?.rcAcq1 || 0);
            tempArrayRcAcq.push(dbListini.value[idListinoSelezionato.value]?.informazioni?.rcAcq2 || 0);
            tempArrayRcAcq.push(dbListini.value[idListinoSelezionato.value]?.informazioni?.rcAcq3 || 0);
        }
        return tempArrayRcAcq;
    }

    function arrayPrListino() {
        let tempArray = [];
        if ('prListino' in elementoSelezionato.value) {
            tempArray.push(elementoSelezionato.value.prListino);
        } else {
            tempArray.push(elementoSelezionato.value.prListinoAcq || 0);
            tempArray.push(elementoSelezionato.value.prListinoVen || 0);
        }
        return tempArray;
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare l'articolo?"
        };
    }

</script>